// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"185":"css/app.6957","7381":"css/admin-app.6957"}[chunkId] + ".css";
};